export const clamp = (min, max) => (value) => {
  return Math.min(max, Math.max(min, value));
};

export const convertStringToAmountInCents = (loanFormValues, fieldName) => {
  const amountInCentsInitialValue =  loanFormValues[fieldName];
  const amountInCentsValue = (parseFloat(amountInCentsInitialValue)) * 100;
  const formattedPayloadValues = {...loanFormValues, [fieldName]: Math.round(amountInCentsValue)};
  return formattedPayloadValues;
};

export const convertStringToFloatAddContractualPayment = (loanFormValues, fieldName, contractedPaymentAmount) => {
  const amountInCentsInitialValue = loanFormValues[fieldName];
  const formattedPayloadValues = {...loanFormValues, [fieldName]: parseFloat(amountInCentsInitialValue) + contractedPaymentAmount};
  return formattedPayloadValues;
}